/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'sites/svenskdam/components/standalone/Page4XX/theme';

export const Page4XXTheme = theme;
